// Step definitions for the user-triggered guided tours (MVP: the four
// foundational input phases). Each step targets a real field/button by its
// data-testid so the coach-mark overlay can highlight it.
const sel = (t) => `[data-testid="${t}"]`;

export const SETUP_TOURS = {
  entity: {
    name: "Legal Entity",
    steps: [
      { selector: sel("setup-field-name"), title: "Entity name", body: "Enter your registered company name exactly as it appears on ACRA — this is the legal party to every contract." },
      { selector: sel("setup-field-type"), title: "Entity type", body: "Pick Landscape maintenance or Design & build so ROOTS tailors the workflow." },
      { selector: sel("setup-field-registration_no"), title: "Registration no. (UEN)", body: "Your Singapore UEN / company registration number — it appears on reports and tender packs." },
      { selector: sel("setup-field-notes"), title: "Notes", body: "Optional internal notes, e.g. a parent group or billing reference." },
      { selector: sel("setup-save-button"), title: "Save the entity", body: "Save to create the entity. The wizard's Organisation phase ticks off automatically." },
    ],
  },
  site: {
    name: "Site",
    steps: [
      { selector: sel("setup-field-name"), title: "Site name", body: "Name the park, estate or streetscape you maintain." },
      { selector: sel("setup-field-site_type"), title: "Site type", body: "Choose the category — it drives the right indicators and benchmarks." },
      { selector: sel("setup-field-area_sqm"), title: "Area (m²)", body: "Total maintained area in square metres. Used for coverage and value calculations." },
      { selector: sel("setup-field-location"), title: "Location", body: "Address or locality so crews and clients know where it is." },
      { selector: sel("setup-save-button"), title: "Save the site", body: "Save, then add Zones to break the site down." },
    ],
  },
  zone: {
    name: "Zone",
    steps: [
      { selector: sel("setup-field-site_id"), title: "Parent site", body: "Pick the site this zone belongs to." },
      { selector: sel("setup-field-name"), title: "Zone name", body: "e.g. 'Front lawn' or 'Rain garden A'." },
      { selector: sel("setup-field-zone_type"), title: "Zone type", body: "Turf, shrub bed, rain garden or tree belt — defines the care regime." },
      { selector: sel("setup-field-area_sqm"), title: "Zone area (m²)", body: "Area of this zone; ROOTS checks it against the site total." },
      { selector: sel("setup-save-button"), title: "Save the zone", body: "Save and repeat for each distinct area of the site." },
    ],
  },
  asset: {
    name: "Asset",
    steps: [
      { selector: sel("setup-field-site_id"), title: "Site", body: "Which site this asset sits on." },
      { selector: sel("setup-field-zone_id"), title: "Zone (optional)", body: "Narrow it to a specific zone if relevant." },
      { selector: sel("setup-field-name"), title: "Asset name", body: "e.g. 'Main irrigation valve' or 'Heritage rain tree'." },
      { selector: sel("setup-field-asset_type"), title: "Asset type", body: "Valve, meter, plant cohort or equipment." },
      { selector: sel("setup-field-code"), title: "Asset code", body: "Your internal tag or serial for traceability." },
      { selector: sel("setup-save-button"), title: "Save the asset", body: "Save to finish building your Places & assets foundation." },
    ],
  },
  contract: {
    name: "Contract",
    steps: [
      { selector: sel("setup-field-entity_id"), title: "Legal entity", body: "The company party to this maintenance agreement." },
      { selector: sel("setup-field-name"), title: "Contract name", body: "A clear label, e.g. 'Tampines Town Council 2026'." },
      { selector: sel("setup-field-scope"), title: "Scope", body: "Summarise what's covered — mowing, pruning, irrigation, etc." },
      { selector: sel("setup-field-client_owner"), title: "Client owner", body: "The client's contact or department responsible." },
      { selector: sel("setup-field-value_sgd"), title: "Contract value (SGD)", body: "Total contract value — needed before the wizard unlocks operations." },
      { selector: sel("setup-save-button"), title: "Save the contract", body: "Tick the sites it covers above, set the term, then Save." },
    ],
  },
};

export const DIAGNOSE_TOUR = {
  name: "Diagnose",
  steps: [
    { selector: `[data-testid="diagnose-field-defect-title"]`, title: "Defect title", body: "Name the recurring problem or data gap, e.g. 'Standing water at Zone B'." },
    { selector: `[data-testid="diagnose-field-defect-kind"]`, title: "Kind", body: "Recurring defect (a physical issue) or data gap (missing information)." },
    { selector: `[data-testid="diagnose-save-button"]`, title: "Log it", body: "Save the defect, then use Propose to add interventions to the ranked queue." },
  ],
};
